module.exports = __webpack_public_path__ + "static/after4-1418fd71cc42abcdaba9daf5bede96a3.jpg";